import { ListCountriesActions, ListCountriesRequestAction } from './../../ducks/countries/listCountries';
import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler, applyQueryString } from 'services';

export function* listCountriesRequest(action: any) {
  const { query = {}, onSuccess, onFailure }: ListCountriesRequestAction = action;
  try {
    const url = applyQueryString('countries', {
      ...query,
      asList: 1,
      orderBy: 'name',
      direction: 'asc',
    });
    const { data } = yield call(api.get, url);
    onSuccess && onSuccess();
    yield put(ListCountriesActions.success(data));
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(ListCountriesActions.failure(errorMessage));
  }
}
